import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IResourceSpaceResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IResourceSpaceResponseInstance'

export function mapResourceSpaceResponseInstance(resourceSpace: IToJson<IResourceSpaceResponseInstance>): IResourceSpaceResponseInstance {
  return {
    ...resourceSpace,
  } as IResourceSpaceResponseInstance // TODO: TS: Remove "as ..."
}

